import {
  wrapperStyles,
  containerStyles
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  sectionWrapperStyles,
  sectionWrapperTabletStyles,
  sectionWrapperMobileStyles,
  wrapperWithMarginStyles,
  wrapperWithMarginTabletStyles,
  typoHeader,
  typoHeaderMobile,
  typoParagraph
} from 'components/Templates/styles/Red/commonObjectsStyles';

/* eslint-disable */
export default
{
  wrapper: {
    '0': {
      ...wrapperStyles,
      ...sectionWrapperStyles,
      'background-color': '{backgroundColor}'
    },
    '76_8' : {
      ...sectionWrapperTabletStyles
    },
    '37_5' : {
      ...sectionWrapperMobileStyles
    },
  },
  videoContainer: {
    '0': {
      ...containerStyles,
    },
  },
  sectionTitle: {
    '0': {
      ...typoHeader,
    },
    '76_8' : {
      ...typoHeaderMobile,
    }
  },
  wrapperWithMargin: {
    '0': {
      ...wrapperWithMarginStyles
    },
    '76_8' : {
      ...wrapperWithMarginTabletStyles
    }
  },
  videoParagraph: {
    '0': {
      ...typoParagraph,
      'margin-bottom' : '5rem'
    },
    '76_8' : {
      'margin-bottom' : '3rem'
    }
  },
  descriptionWrapper: {
    '0': {
    }
  }
};
